import script from "./InsertUrlVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsertUrlVideo.vue?vue&type=script&setup=true&lang=ts"

import "./InsertUrlVideo.vue?vue&type=style&index=0&id=33da8d51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33da8d51"]])

export default __exports__